
import axiosInstance from "../Utils/axiosInterceptor";
import {Service} from "../models/Service";


export class ServiceSelectionService {

    static async getAllServices() {
        try {
            const response = await axiosInstance.get<Service[]>("/get_services/");
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    static async setSelectedServices(service: Service) {
        try {
            const response = await axiosInstance.post<Service>("/set_selected_services/", service);
            return response.data;
        } catch (error) {
            throw error;
        }
    }
}